import { InjectionToken, inject } from "@angular/core";
import { DataLayer } from "../types/data-layer.type";
import { NG_DATA_LAYER } from "./data-layer-token";
import { NG_WINDOW } from "./window-token";
import { GtagFn } from "../types/gtag-token.type";

/**
 * Check if there is some global function called gtag on Window object, or create an empty function to doesn't brake codes...
 */
export function getGtagFn(window: Window, dataLayer: DataLayer): GtagFn {
  return window
    ? (window["gtag"] =
        window["gtag"] ||
        function () {
          dataLayer.push(arguments as any);
        })
    : null;
}

/**
 * Provides an injection token to access Google Analytics Gtag Function
 */
export const NG_GTAG_FN = new InjectionToken<GtagFn>("ng-gtag-fn", {
  providedIn: "root",
  factory: () => getGtagFn(inject(NG_WINDOW), inject(NG_DATA_LAYER)),
});
